import { NICmsContentComponent, NICmsContentField } from '@icms/core/content';
import { NCmsComponentNewsletter } from './cms-component-newsletter.interface';

export const CMS_COMPONENT_NEWSLETTER_CONFIG = <Omit<NICmsContentComponent.IMeta<NICmsContentComponent.IComponent>, 'type'>>{
    id: NCmsComponentNewsletter.ID,
    isAdvanced: true,
    name: 'Inline newsletter form',
    description: 'Component is optimised to work with footer',
    image: '/common/cms/newsletter-component.png',
    tags: ['newsletter', 'footer'],
    fields: [
        // general
        {
            type: NICmsContentField.EFieldType.label,
            key: 'section-general',
            title: 'General'
        },
        {
            key: 'text',
            type: NICmsContentField.EFieldType.text,
            title: 'Success message'
        },
        {
            key: 'source',
            type: NICmsContentField.EFieldType.text,
            title: 'Source id for tracking'
        }
    ]
};
